<template>
    <div id="vehicle_model_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="fuelHeaderupdate" v-if="$route.params.id > 0">Update Fuel Island Product</span>
                    <span class="page-title" id="fuelHeaderCreate" v-else>Add Fuel Island Product</span>
                    <button type="submit" class="btn btn-primary pull-right" v-on:click.prevent="BackIslandProductlList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="fuelIslandCreate">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="location_id">Location:</label>
                                        <v-select v-model="location_id" name="location_id" placeholder="Select Location."
                                                    label="text"
                                                    :options="locationArr">
                                        </v-select>
                                        <div class="field-error">{{location_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="tank_no">Item:</label>
                                        <v-select v-model="item_id" name="item" placeholder="Select Item."
                                                    label="text"
                                                    :options="componentArr">
                                        </v-select>
                                        <div class="field-error">{{item_error_msg}}</div>
                                    </div>
                                    <!-- <div :class="'col form-group '+ hideForExtFuel">
                                        <label class="control-label require" for="tank_no">Tank Number:</label>
                                        <input type="text" class="form-control" v-model="tank_no" id="tank_no" placeholder="Enter Tank Number" name="tank_no" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{tank_no_error_msg}}</div>
                                    </div> -->
                                    <div :class="'col form-group '+ hideForExtFuel">
                                        <label class="control-label require" for="cost_method_id">Cost Method:</label>
                                        <v-select v-model="cost_method_id" name="cost_method_id" placeholder="Select Cost Method."
                                                    label="text"
                                                    :options="costMethodArr">
                                        </v-select>
                                        <div class="field-error">{{cost_method_error_msg}}</div>
                                    </div>
                                    <div :class="'col form-group '+ hideForExtFuel">
                                        <label class="control-label require" for="capacity">Capacity:</label>
                                        <input type="number" class="form-control" v-model="capacity" id="capacity" placeholder="Enter Tank Capacity" name="capacity"
                                                         @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{capacity_error_msg}}</div>
                                    </div>
                                    <div :class="'col form-group '+ hideForExtFuel">
                                        <label class="control-label require" for="unit_id">UOM:</label>
                                        <v-select v-model="measurement_unit_id" name="unit_id" placeholder="Select UOM"
                                                    label="text"
                                                    :options="vomArr">
                                        </v-select>
                                        <div class="field-error">{{ measurement_unit_error_msg }}</div>
                                    </div>
                                    <div :class="'col form-group '+ hideForExtFuel">
                                        <label class="control-label">Fuel Tax</label>
                                        <div class="custome-radiobtn">
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="fuel_tax1">Yes
                                                    <input type="radio" v-model="fuel_tax" :value="1" id="fuel_tax1" name="fuel_tax">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="fuel_tax2"> No
                                                    <input type="radio" v-model="fuel_tax" :value="0" id="fuel_tax2" name="fuel_tax">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="field-error"></div>
                                    </div>
                                </div>
                                <div class="field-error check-error">{{common_error_msg}}</div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-offset-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createVehicleModelBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateIslandProduct" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createVehicleModelBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateIslandProduct" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueVehicleModelBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateIslandProduct(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelVehicleModelBtn" class="btn btn-tertiary" v-on:click.prevent="BackIslandProductlList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>    
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import {contractMixins} from '../mixins/contractMixins';
export default {
  name: "VehicleModelCreate",
  
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Fuel Island Product | " +process.env.COPYRIGHT_NAME : "Create Fuel Island Product | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins,contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    location_id: null,
    cost_method_id:{ text: 'Entered', value: 'entered' },
    capacity:'',
    fuel_tax:0,
    locationArr: [],
    vomArr:[],
    measurement_unit_id:null,
    // tank_no:"",
    componentArr:[],
    item_id:null,
    loading:false,
    location_error_msg: "",
    cost_method_error_msg: "",
    capacity_error_msg: "",
    // tank_no_error_msg: "",
    measurement_unit_error_msg:"",
    item_error_msg: "",
    common_error_msg:"", 
    hideForExtFuel:"",
    fuelCategory:"",
  }),
  watch: {

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_fuel_island_product') {
                        self.cantAccessPage = true;

                    }
                }
            }

        },
        //on change check fuel type if external than other fields are not requried
        item_id: function (item) {
            var self = this;
            if ( item.catCode.toLowerCase() == "fuelns" ) {
                self.hideForExtFuel = "hide";
                self.cost_method_id = { text: 'Entered', value: 'entered' };
                self.fuelCategory = "fuelns";
            } else {
                self.hideForExtFuel = "";
                self.cost_method_id = { text: 'Average Cost', value: 'average cost' };
                self.fuelCategory = "fuel";
            }
        }

  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();

        self.loadFieldData(['location','measurementUnit','fuelItems']);
        var path = window.location.pathname;
        var segments = path.split("/");

        if (segments[3]) {
            self.loadFuelIslandProduct();
        }
  },
  methods: {

    BackIslandProductlList() {
      var self = this;
      self.$router.push("/fuel-island-product/list");
    },
    CreateIslandProduct(flag) {
      var self = this;
      var error = false;

    //   self.code = self.tank_no.trim();

      self.location_error_msg= "";
      self.cost_method_error_msg= "";
      self.capacity_error_msg= "";
    //   self.tank_no_error_msg= "",
      self.measurement_unit_error_msg="";
      self.item_error_msg="";
      self.common_error_msg = "";

      if ((!self.capacity || self.capacity == null || self.capacity == "" || self.capacity == 0) && self.hideForExtFuel == "" ) {
        self.capacity_error_msg = "Capacity Required.";
        error = true;
      }
    //   if ((!self.tank_no || self.tank_no == null || self.tank_no == "") && self.hideForExtFuel == "" ) {
    //         self.tank_no_error_msg = "Tank Number Required.";
    //         error = true;
    //   }
      if (self.location_id == null || !self.location_id.value) {
        self.location_error_msg = "Location  Required.";
        error = true;
      }
      if (self.measurement_unit_id == null || !self.measurement_unit_id.value) {
          self.measurement_unit_error_msg = "Measurement Unit  Required.";
          error = true;
      }
      if (self.cost_method_id == null || !self.cost_method_id.value) {
        self.cost_method_error_msg = "Cost Method Required.";
        error = true;
      }
      if (self.item_id == null || !self.item_id.value) {
            self.item_error_msg = "Item Required.";
            error = true;
      }

      if (!error) {

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createVehicleModelBtn").val("Updating ...");
                $("#createVehicleModelBtn").prop("disabled", true);
                $("#cancelVehicleModelBtn").prop("disabled",true);

            } else {

                if (flag == "Save and Continue") {

                    $("#createAndContinueVehicleModelBtn").val("Saving ...");
                    $("#createVehicleModelBtn").prop("disabled", true);
                    $("#createAndContinueVehicleModelBtn").prop("disabled", true);
                    $("#cancelVehicleModelBtn").prop("disabled",true);

                }else{

                    $("#createVehicleModelBtn").val("Saving ...");
                    $("#createVehicleModelBtn").prop("disabled", true);
                    $("#createAndContinueVehicleModelBtn").prop("disabled", true);
                    $("#cancelVehicleModelBtn").prop("disabled",true);
                }
               
            }
            var fields = $('#fuelIslandCreate').serializeArray();

            fields.push({name: "measurement_unit_id", value: self.measurement_unit_id.value});
            fields.push({name: "cost_method_id", value: self.cost_method_id.value});
            fields.push({name: "location_id", value: self.location_id.value});
            fields.push({name: "item_id", value: self.item_id.value});
            fields.push({name: "id", value: segments[3]});
            fields.push({name:"fuel_cat",value: self.fuelCategory});

            $.ajax({
                url: process.env.ROOT_API + "/fuel-island-product/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehicleModelBtn").val("Update");
                        $("#createVehicleModelBtn").prop("disabled", false);
                        $("#cancelVehicleModelBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueVehicleModelBtn").val("Save and Continue");
                            $("#createVehicleModelBtn").prop("disabled", false);
                            $("#createAndContinueVehicleModelBtn").prop("disabled", false);
                            $("#cancelVehicleModelBtn").prop("disabled",false);

                        }else{

                            $("#createVehicleModelBtn").val("Save");
                            $("#createVehicleModelBtn").prop("disabled", false);
                            $("#createAndContinueVehicleModelBtn").prop("disabled", false);
                            $("#cancelVehicleModelBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {
                            
                            self.cost_method_id = null;
                            self.location_id = null;
                            self.measurement_unit_id = null;
                            self.capacity='';
                            self.item_id=null;
                            // self.tank_no="";
                            self.fuel_tax = 0;
                            var obj = self.vomArr;
                            $.each(obj, function (key, uomvalue) {
                                if (uomvalue.symbol == 'GAL') {
                                    self.measurement_unit_id = {
                                        value: uomvalue.value,
                                        text: uomvalue.text,
                                    };
                                }
                            });
                            // self.manufacturercodeArr = "";

                        }else{
                            self.$router.push("/fuel-island-product/list");
                        }
                        
                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                                self.common_error_msg += data.content[i] + "\n";
                            }
                            // $("#errorMsg").html(err);
                            // $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                // $(".alert-warning").removeClass("show");
                                // $(".alert-warning").addClass("hide");
                                self.common_error_msg = "";
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehicleModelBtn").val("Update");
                        $("#createVehicleModelBtn").prop("disabled", false);
                        $("#cancelVehicleModelBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            // $("#fuelIslandCreate").trigger("reset");
                            
                            $("#createAndContinueVehicleModelBtn").val("Save and Continue");
                            $("#createVehicleModelBtn").prop("disabled", false);
                            $("#createAndContinueVehicleModelBtn").prop("disabled", false);
                            $("#cancelVehicleModelBtn").prop("disabled",false);

                        }else{

                            $("#createVehicleModelBtn").val("Save");
                            $("#createVehicleModelBtn").prop("disabled", false);
                            $("#createAndContinueVehicleModelBtn").prop("disabled", false);
                            $("#cancelVehicleModelBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'island-product-create')
                }
            });  
      }else{
            self.errorValidationFocus();
      }
    },
    loadFuelIslandProduct() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/fuel-island-product/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {

                    if(data.content.uom_id == null) {
                        self.measurement_unit_id = null;
                    }else{
                        self.measurement_unit_id = {value: data.content.uom_id, text: self.titleCase(data.content.measurement_unit + " (" + data.content.symbol +")")};
                    }
                    if(data.content.location_id == null) {
                        self.location_id = null;
                    }else{
                        self.location_id = {value: data.content.location_id, text: self.titleCase(data.content.company_name + " | " + data.content.loc_code )};
                    }
                    if(data.content.item_id == null) {
                        self.item_id = null;
                    }else{
                        self.item_id = {value: data.content.item_id, text: self.titleCase(data.content.item_code+" | "+data.content.item_name)};
                    }
                    self.fuel_tax=(data.content.fuel_tax=='no')?0:1;
                    // self.tank_no=data.content.tank_no;
                    self.cost_method_id={value: data.content.cost_method, text: self.titleCase(data.content.cost_method)};
                    self.capacity=data.content.capacity;

                    //to hide other columns for external fuel
                    if ( data.content.itemCatCode.toLowerCase() == "fuelns" ) {
                        self.hideForExtFuel = "hide";
                        self.cost_method_id = { text: 'Entered', value: 'entered' };
                        self.fuelCategory = "fuelns";
                    } else {
                        self.hideForExtFuel = "";
                        self.cost_method_id = { text: 'Average Cost', value: 'average cost' };
                        self.fuelCategory = "fuel";
                    }
                    
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'island-product-by-id')
            }
        });
    },
    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/FuelIslandProductCreate.vue